<template>
  <SingleSliderWithTwoColors
    v-model:sliderValue="selected"
    :step="step"
    :min="min"
    :max="max"
  />
</template>

<script>
import SingleSliderWithTwoColors from '@/components/SingleSliderWithTwoColors.vue';
import * as utils from '@/assets/js/utils.js';

export default {
  name: "TrainValSplitSlider",
  components: {
    SingleSliderWithTwoColors,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: [
    'update:modelValue',
  ],
  data() {
    return {
      min: 0,
      max: 100,
      selected: 80,
      step: 1,
    };
  },
  computed: {
    isActive() {
      return this.selected > 0 || this.selected < 1;
    },
    tagValue() {
      return `${this.selected} - ${100 - Number(this.selected)}`;
    },
    result() {
      return [this.selected, 100 - Number(this.selected), 0];
    },
  },
  watch: {
    selected() {
      this.debouncedUpdateFilters();
    },
  },
  created() {
    this.debouncedUpdateFilters = utils.debounce(this.updateFilters, 10);
  },
  mounted() {
    if (this.modelValue) {
      this.selected = this.modelValue[0];
    }
  },
  methods: {
    async updateFilters() {
      if (!this.isActive) {
        this.$emit('update:modelValue', null);
        return;
      }
      this.$emit('update:modelValue', this.result);
    },
  },
};
</script>
